import React from "react";
import { useMemo } from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";

var instance;

const AccessibilityWidget = () => {
  const { getLanguage } = useContent();
  const { desktopCondition } = useMediaQueries();
  useMemo(() => {
    //change configuration only for when user changing language
    if (getLanguage() && desktopCondition) {
      //UserWay settings (accessibility)
      var config = {
        position: getLanguage() === "he" ? 3 : 5,
        language: getLanguage(),
        size: "small",
        type: "chair",
        account: "0uoIdwnxDA",
      };
      const isInitialized = init(config);
      if (isInitialized) {
        document.addEventListener("userway:init_completed", function (event) {
          instance = event.detail.userWayInstance;
        });
      }
      var userway = document.querySelector("div.userway");
      if (userway) {
        userway.setAttribute(
          "class",
          `userway userway_p${getLanguage() === "he" ? "5" : "3"}`
        );
      }
      return () => {
        instance.iconVisibilityOff();
      };
    }
  }, [getLanguage(), desktopCondition]);
  return <></>;
};
export default AccessibilityWidget;

const init = (config) => {
  //if already initialized - do nothing.
  if (window._userway_config) return false;

  window._userway_config = config;
  function e(t, n) {
    var o = void 0,
      i = document.body || document.head;
    let j = i
      ? ((o = document.createElement("script")),
        (o.onload = function () {
          n && n();
        }),
        (o.src = t),
        i.appendChild(o))
      : setTimeout(function () {
          e(t, n);
        }, 500);
  }
  if (!new RegExp("(bot|crawler)", "i").test(navigator.userAgent)) {
    var t = window.config;
    (navigator.userAgent.match(/mobile/i) &&
      t &&
      ("false" === t.mobile || !1 === t.mobile)) ||
      e("https://cdn.userway.org/widget.js");
  }
  return true;
};
